import axios, { AxiosResponse } from 'axios';
import { GET_MENU_URL, GET_MENU_HELP_URL } from './constants';
import { GetMenuHelpReq, GetMenuHelpRes } from './types';

/**
 * Portal menu names are stored as "Web - <title>" (legacy rows: a trailing ".")
 * because M_MENU names are unique across the desktop ERP too. The API strips
 * this; doing it here as well keeps the sidebar right against an older API.
 */
const menuTitle = (title: unknown) =>
  String(title ?? '')
    .replace(/^Web - /i, '')
    .replace(/\.+$/, '')
    .trim();

const cleanTitles = (items: any[]): any[] =>
  items.map((item) => ({
    ...item,
    title: menuTitle(item.title),
    children: Array.isArray(item.children) ? cleanTitles(item.children) : item.children,
  }));

export const getMenuItems = async (): Promise<any> => {
  const response = await axios.get(GET_MENU_URL);
  const result = response.data.result;
  return Array.isArray(result) ? cleanTitles(result) : result;
};

export const getMenuHelp = async (
  payload: GetMenuHelpReq
): Promise<AxiosResponse<GetMenuHelpRes>> => {
  try {
    const response = await axios.post<GetMenuHelpRes>(
      GET_MENU_HELP_URL,
      payload
    );
    return response;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
